import { Paper, styled } from "@mui/material"

export const SuggestionsPaper = styled(Paper, {
    name: "SuggestionsPaper",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})(({ theme }) => ({
    overflow: "hidden",
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: `0 0 ${theme.radius.default} ${theme.radius.default}`,
    backgroundColor: theme.palette.background.paper,
    position: "absolute",
    zIndex: 10,
    marginTop: "-1px",
    padding: 0,
    width: "auto",

    "&::-webkit-scrollbar-track": {
        background: theme.palette.background.paper, // scrollbar background
    },

    // Firefox Unterstützung
    scrollbarColor: `#888 ${theme.palette.background.paper}`, // ${colors.grey[100]}`,
}))
